import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Dealers extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Dealers._name, API.RequestType.READ_ALL);
		super(props, model);
		if (props.duplicateFilter) {
			this.requestData = this.requestMatchingDuplicates;
		}

	}


	requestMatchingDuplicates = async (page, sorted) => {
		this.model.source = 'dealer_duplicate';
		this.model.search = this.props.duplicateFilter;
		this.model.limit = this.state.limit;
		this.model.offset = page * (this.state.limit || 0);
		this.model.sort = sorted[0] ? sorted[0].id : 'pkey';
		this.model.order = sorted[0] && sorted[0].desc ? 'desc' : 'asc';
		try {
			const matches = await this.model.submit(this, API.RequestType.READ_ALL);
			return {rows: matches.items || [], pages: this.state.limit ? Math.ceil(matches.total / this.state.limit) : 1};
		} catch (error) {
			this.setState({loading: false});
			return {rows: [], pages: 0};
		}
	};

	handleShowDuplicates = async () => {
		this.setState({loading: true})
		this.request = 'GET_ALL_DEALERS_DUPLICATES';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL_DEALERS_DUPLICATES');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})
	}

	handleShowRegular = async () => {
		this.setState({loading: true})
		this.request = 'GET_ALL';
		this.model.filter = {};
		let data = await this.model.submit(null, 'GET_ALL');
		let pages = Math.ceil(data.total/this.state.limit);
		this.setState({data: data.items, loading: false, pages})

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Company Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/dealers/" + props.original.binary_id + '-' + props.value}>{props.original.name_company}</Link>
			},
			{
				Header: "Display Name",
				id: "name_display",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.name_display)
			},
			{
				Header: "FFL",
				id: "ffl",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.ffl)
			},
			{
				Header: "Phone",
				id: "number_main",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.number_main)
			},
			{
				Header: "Address",
				id: "street_1",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.street_1)
			},
			{
				Header: "City",
				id: "city",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.city)
			},
			{
				Header: "State",
				id: "state",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.state)
			},
			{
				Header: "Zip Code",
				id: "zip",
				/** @param {Dealers_Object} obj */
				accessor: obj => (obj.zip)
			},
			{
				Header: "FFL Expiration",
				id: "ffl_expiration",
				/** @param {Dealers_Object} obj */
				accessor: obj => {

					return obj.ffl_expiration ? moment(obj.ffl_expiration)
						.local()
						.format("MM/DD/YYYY") : ""
				}
			},

			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={this.props.duplicateFilter ? `/dealers/${props.original.binary_id}-${props.original.pkey}#duplicates` : `/dealers/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={this.props.duplicateFilter ? "fa fa-balance-scale" : "fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.props.duplicateFilter ? <span>Dealer duplicates matching the names or FFL you entered. Open a dealer’s duplicate review to resolve matches.</span> : <>
							{this.renderSearch('Dealers', "")}
							{this.request === 'GET_ALL_DEALERS_DUPLICATES' ? <Button color="primary" onClick={this.handleShowRegular} style={{marginLeft: '25px'}}>Show Regular</Button> :
								<Button color="warning" onClick={this.handleShowDuplicates} style={{marginLeft: '25px'}}>Show Duplicates</Button> }
							</>}
							{this.renderHeaderRight("Dealers", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						className="-striped -highlight"

						pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
						renderPageSizeOptions={this.renderPageSizes}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
